<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-8 text-center">
        <!-- Loading State -->
        <div v-if="loading">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <h3 class="mt-3">Verificando pago...</h3>
          <p>Por favor espere, estamos confirmando su pago con Mercado Pago.</p>
        </div>

        <!-- Approved State -->
        <div v-else-if="status === 'PROCESADO' || status === 'APROBADO'">
          <div class="alert alert-success">
            <h4 class="alert-heading">¡Pago Aprobado!</h4>
            <p>Su pago ha sido procesado exitosamente. Generando su pedido...</p>
          </div>
        </div>

        <!-- Pending/In Process State -->
        <div v-else-if="status === 'PENDIENTE' || status === 'PROCESANDO'">
          <div class="alert alert-warning">
            <h4 class="alert-heading">Pago Pendiente</h4>
            <p>El pago aún se encuentra pendiente de confirmación.</p>
            <p>Si ya realizó el pago, aguarde unos instantes. Esta pantalla se actualizará automáticamente.</p>
            <button class="btn btn-primary mt-3" @click="verificarEstado">Actualizar Estado</button>
          </div>
        </div>

        <!-- Rejected/Error State -->
        <div v-else>
          <div class="alert alert-danger">
            <h4 class="alert-heading">Problema con el Pago</h4>
            <p>Hubo un problema con su pago o el pedido no fue encontrado.</p>
            <p v-if="errorMessage">{{ errorMessage }}</p>
            <hr>
            <p class="mb-0">Por favor, intente nuevamente o contacte a soporte.</p>
            <router-link to="/carrito" class="btn btn-secondary mt-3">Volver al Carrito</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiServer from '../api';
import { mapState, mapActions } from 'vuex';

function leerParam(nombre) {
  const search = new URLSearchParams(window.location.search);
  if (search.get(nombre)) return search.get(nombre);
  const hash = window.location.hash || '';
  const indice = hash.indexOf('?');
  if (indice >= 0) {
    return new URLSearchParams(hash.slice(indice + 1)).get(nombre);
  }
  return null;
}

export default {
  name: 'PagoResultado',
  computed: {
    ...mapState(['usuario'])
  },
  data() {
    return {
      loading: true,
      status: '',
      errorMessage: '',
      pollingInterval: null,
      preference_id: null
    };
  },
  async created() {
    this.preference_id = this.$route.query.preference_id || leerParam('preference_id');
    
    if (!this.preference_id) {
      this.status = 'ERROR';
      this.errorMessage = 'No se proporcionó ID de preferencia de pago.';
      this.loading = false;
      return;
    }

    await this.verificarEstado();

    // Si sigue pendiente después de la primera carga, iniciar polling corto
    if (this.status === 'PENDIENTE' || this.status === 'PROCESANDO') {
        this.pollingInterval = setInterval(this.verificarEstado, 5000); // Check every 5 seconds
    }
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  methods: {
    ...mapActions(['borrarTodoElCarrito']),
    async verificarEstado() {
      try {
        const response = await ApiServer.getPedidoPendienteMP(this.preference_id);
        
        if (response) {
            this.status = (response.estado || '').toUpperCase();
            
            if (this.status === 'PROCESADO' || this.status === 'APROBADO') {
                this.loading = false;
                if (this.pollingInterval) clearInterval(this.pollingInterval);
                
                // Redirigir a PedidoIngresado
                const datosPedido = typeof response.datos_pedido === 'string' 
                                    ? JSON.parse(response.datos_pedido) 
                                    : response.datos_pedido;
                                    
                const nroPedido = datosPedido ? datosPedido.nro_cpr : null;

                if (this.usuario && this.usuario.cod_cli) {
                  try {
                    await ApiServer.deleteVaciarCarrito(this.usuario.cod_cli);
                  } catch (error) {
                    console.log(error);
                  }
                }
                this.borrarTodoElCarrito();

                setTimeout(() => {
                    if (nroPedido) {
                        this.$router.push({ name: 'PedidoIngresado', params: { nroPedido: nroPedido } });
                    } else {
                        // Fallback si no encontramos el número de pedido
                        this.$router.push('/mispedidos'); 
                    }
                }, 2000);
            } else if (this.status === 'PENDIENTE' || this.status === 'PROCESANDO') {
                this.loading = false; // Mostrar pantalla de pendiente
            } else {
                 this.loading = false;
                 if (this.pollingInterval) clearInterval(this.pollingInterval);
            }
        }
      } catch (error) {
        console.error('Error verificando estado:', error);
        this.loading = false;
        this.status = 'ERROR';
        this.errorMessage = 'No se pudo verificar el estado del pago.';
      }
    }
  }
};
</script>

<style scoped>
.container {
    max-width: 800px;
}
</style>
